module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/projects/tallegg-tvc.md absPath of file >>> MarkdownRemark","html":"","excerpt":"","tags":["TVC"],"frontmatter":{"date":"August 31, 2026","title":"Tallegg","videoUrl":"https://vimeo.com/1008770780","image":"/img/tallegg.jpg","credits":""}}},"pathContext":{"id":"/opt/build/repo/src/pages/projects/tallegg-tvc.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-tallegg-tvc.json
// module id = 632
// module chunks = 104981817426404